import React from "react";

const services = [
  {
    title: "Social Media Marketing",
    image: "/assets/smmLogo.webp",
  },
  {
    title: "Digital Media Buying",
    image: "/assets/digitaMediaBuyingLogo.webp",
  },
  {
    title: "Event Coordination",
    image: "/assets/EventCordination.webp",
  },
  {
    title: "Merchandise Design and Give away",
    image: "/assets/merchandiseDesignLogo.webp",
  },
  {
    title: "Talent Management",
    image: "/assets/TalentManagementLogo.webp",
  },
  {
    title: "Event Coverage (Photography and Videography)",
    image: "/assets/EventCoverageLogo.webp",
  },
  {
    title: "Content Creation",
    image: "/assets/ContentCreationLogo.webp",
  },
  {
    title: "IMDB and Wikipedia Creation and Management",
    image: "/assets/WikipediaIMDBLogo.webp",
  },
  {
    title: "AR Filter Design for Instagram",
    image: "/assets/ARFilterDesignLogo.webp",
  },
  {
    title: "Search Engine Optimization",
    image: "/assets/SEOlogo.webp",
  },
  {
    title: "Byte Dance (TikTOK) partnership with Money Back Guarantee",
    image: "/assets/TiktokLogo.webp",
  },
];

const Section4 = () => {
  return (
    <section className="py-12 px-4 bg-gray-100">
      <div className="max-w-6xl mx-auto text-center flex flex-col gap-4">
        <h2 className="text-3xl font-bold text-red-600 ">
          SERVICES WE OFFER
        </h2>
        <div className="w-[20%] h-[6px] m-auto  bg-gray-800  "></div>
        <div className="grid grid-cols-2  md:grid-cols-3 lg:grid-cols-4 mt-10  gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="p-2 sm:p-6 bg-white shadow-xl rounded-xl text-center flex flex-col items-center"
            >
              <img
                src={service.image}
                alt={service.title}
                className="w-16 h-16 mb-4"
              />
              <p className="text-sm sm:text-lg font-semibold text-gray-800">
                {service.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Section4;
